(function () {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('landing-page', {
                parent: 'app',
                url: '/landing-page',
                data: {
                    authorities: ['ROLE_PATIENT'],
                    pageTitle: 'ipmApp.landingPage.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/landing-page/landing-page.html',
                        controller: 'LandingPageController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('landingPage');
                        return $translate.refresh();
                    }],
                },
                params: {
                    id: null
                }
            });

    }

})();
